import React from "react";
import { UseDownloadAsset } from "../../../api/calls/Queries";
import { getLanguageFile } from "../../common/GetLanguageFile";

function OpenImagePopup(props: {
  popup: any;
  setOpen: (bool: boolean) => void;
}) {
  const { popup, setOpen } = props;

  const { data: imageBlob } = UseDownloadAsset(popup?.image);

  return (
    <div>
      <button
        id="popup-close"
        // style={{ position: "absolute", right: "20px" }}
        onClick={() => setOpen(false)}
      >
        {getLanguageFile("generics.close")}
      </button>

      {popup ? (
        <>
          {imageBlob ? (
            <>
              <h3>{popup.title}</h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",

                  justifyContent: "center",
                  maxWidth: "500px",
                  gap: "10px",
                }}
              >
                <img
                  src={imageBlob}
                  alt="AAAAAAA"
                  style={{
                    objectFit: "cover",
                    width: "300px",
                    height: "100%",
                  }}
                ></img>

                {popup.text && <p style={{ flex: "50%" }}>{popup.text}</p>}
              </div>
            </>
          ) : (
            getLanguageFile("generics.loading")
          )}
        </>
      ) : (
        <p> {getLanguageFile("experience.popup_been_deleted")}</p>
      )}
    </div>
  );
}

export default OpenImagePopup;
